import React, { useCallback, useEffect, useState } from 'react'
import CustomFullScreenModal from '../../../../../Elements/modal/CustomFullScreenModal'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import UnpaidOrderModals from './modal'
import { setZReportSelectedOrder, setZReportShowOrder, setZReportShowOrdersTable } from '../../../../../../redux/action/zreport'
import UnpaidOrdersTableV2 from '../../../../../Elements/table/v2/UnpaidOrdersTableV2'
import InfoMessage from '../../../../../Elements/message/InfoMessage'
import Button from '../../../../../Elements/buttons/Button'

const EVENT_Z_INDEX = 111

const defaultFilter = { excludedStatus: ['NOT_ACCEPTED', 'DENIED', 'ABORTED'], closed: false, withOnlyRegisteredPreOrders: true }

const UnpaidOrdersModal = React.memo(({ navigateNext, isOpen: isOpenProp, dateRange, blocking = false, infoMessageKey = 'Reports.ZReports.modal.unpaidOrdersModal.infoMessageManualClose', onClose }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const showOrdersModalFromStore = useSelector(store => store.zReport.orderModal.showOrdersTable)
	const showOrdersModal = isOpenProp ?? showOrdersModalFromStore
	const unpaidOrdersTotalLength = useSelector(store => store.order.unpaidOrdersTotalLength)
	const [dataIsLoaded, setDataIsLoaded] = useState(false)

	useEffect(() => {
		if (showOrdersModal && !dataIsLoaded && unpaidOrdersTotalLength) {
			setDataIsLoaded(true)
		}
	}, [showOrdersModal, dataIsLoaded, unpaidOrdersTotalLength])

	useEffect(() => {
		if (!showOrdersModal) {
			setDataIsLoaded(false)
		}
	}, [showOrdersModal])

	const handleClose = useCallback(() => {
		dispatch(setZReportShowOrdersTable(false))
		dispatch(setZReportSelectedOrder(null))
		setDataIsLoaded(false)
	}, [dispatch])

	const handleNavigateNext = useCallback(() => {
		handleClose()
		navigateNext()
	}, [handleClose, navigateNext])

	useEffect(() => {
		if (showOrdersModal && dataIsLoaded && !unpaidOrdersTotalLength) {
			handleNavigateNext()
		}
	}, [showOrdersModal, dataIsLoaded, unpaidOrdersTotalLength, handleNavigateNext])

	const selectOrder = useCallback(order => {
		dispatch(setZReportSelectedOrder(order))
		dispatch(setZReportShowOrder(true))
	}, [dispatch])

	const noopClose = useCallback(() => {}, [])

	const controlled = isOpenProp !== undefined
	const closeHandler = blocking ? noopClose : (controlled ? (onClose ?? noopClose) : handleClose)
	const showCloseCross = controlled || !blocking
	const showBackButton = !blocking

	return (
		<>
			<CustomFullScreenModal isOpen={showOrdersModal}
														 close={closeHandler}
														 id="report-unpaid-orders-modal"
														 showBackButton={showBackButton}
														 showCloseCross={showCloseCross}
														 enableOutsideClick={!blocking}
														 title={t('Reports.ZReports.modal.unpaidOrdersModal.title')}
														 zIndex={EVENT_Z_INDEX}
														 headerClassname="danger"
														 footerClassname="mobile-column"
														 button={blocking
															 ? <Button color="blue" icon="logout"
																			 text={t('LeftBar.menu.Logout')}
																			 zIndex={EVENT_Z_INDEX} onClick={onClose} />
															 : undefined}>
				<>
					<InfoMessage fullWidth={true} className="font-20 pre-line">{t(infoMessageKey)}</InfoMessage>
					<UnpaidOrdersTableV2 reverse={true}
															 id="report-unpaid-order-table"
															 defaultFilter={defaultFilter}
															 dateRange={dateRange}
															 onClick={selectOrder}
															 onEnter={selectOrder} />
				</>
			</CustomFullScreenModal>
			<UnpaidOrderModals />
		</>)
})
UnpaidOrdersModal.displayName = 'UnpaidOrdersModal'
export default UnpaidOrdersModal
